// src/components/CustomerView/sections/GeneralCustomerView.tsx
import React from 'react';
import InfoField from '../../../Shared/InfoField';
import { ICustomerDetail } from '../../../../types/customer/customerInterfaces';

interface Props {
  detail: ICustomerDetail;
}

const GeneralCustomerView: React.FC<Props> = ({ detail }) => {
  return (
    <>
      {/* Datos mínimos */}
      <section className="mb-8">
        <h3 className="text-gray-700 mb-4 text-lg font-semibold dark:text-white">
          Datos
        </h3>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <InfoField label="Nombre" value={detail.name ?? 'Cliente Varios'} />
        </div>
      </section>

      {/* Observación */}
      <section className="text-sm text-gray-600 dark:text-gray-300">
        <p>
          Este cliente corresponde a la categoría <strong>General</strong>. Por diseño,
          no almacena datos de identificación, ubicación ni clasificación fiscal
          (NIT, NRC, dirección, actividad económica, etc.).
        </p>
      </section>
    </>
  );
};

export default GeneralCustomerView;
